import { useLayoutEffect } from 'react'

/** Explicit screen identity only: never pass dates/options/loading state here. */
export function enterBookingScreen(root, { includeAncestors = true } = {}) {
  if (!root) return
  const containers = [root, ...root.querySelectorAll('*')]
  let parent = includeAncestors ? root.parentElement : null
  while (parent) { containers.push(parent); parent = parent.parentElement }
  for (const element of containers) {
    if (element.scrollTop) {
      const behavior = element.style.scrollBehavior
      element.style.scrollBehavior = 'auto'
      element.scrollTop = 0
      element.style.scrollBehavior = behavior
    }
  }
  const heading = root.querySelector('h1, h2, h3, h4, [role="heading"]') || root
  if (heading) {
    const hadTabIndex = heading.hasAttribute('tabindex')
    if (!hadTabIndex) heading.setAttribute('tabindex', '-1')
    heading.focus({ preventScroll: true })
    if (!hadTabIndex) heading.addEventListener('blur', () => heading.removeAttribute('tabindex'), { once: true })
  }
}

export function useBookingScreenEntry(screenKey, rootRef) {
  useLayoutEffect(() => {
    const root = rootRef ? rootRef.current : document.querySelector('.mp-main')
    enterBookingScreen(root, { includeAncestors: !rootRef })
  }, [screenKey, rootRef])
}
